import styled from "styled-components";
import { styledByTheme } from "../../../../themes/architecture/styled-by-theme";
import { SideMenuLinkIconBase } from "./base/side-menu-link-icon-base.box";

const RouletteSideMenuDefaultIcon = styled(SideMenuLinkIconBase)`
    background-position: ${({active}) => active ? "-495px -412px" : "-495px -381px"};
`;

const RouletteSideMenuWsopIcon = styled(SideMenuLinkIconBase)`
    background-position: ${({active}) => active ? "-561px -477px" : "-562px -449px"};
`;

const RouletteSideMenuCasino777Icon = styled(RouletteSideMenuDefaultIcon)`
    background-position: ${({active}) => active ? "-303px -525px" : "-302px -584px"};
    &:hover {
        background-position: -302px -556px;
    }
`;

export const RouletteSideMenuIcon = styledByTheme(RouletteSideMenuDefaultIcon)
    .forCasino777(RouletteSideMenuCasino777Icon)
    .forWsop(RouletteSideMenuWsopIcon)
    .apply();

